import { ROUTES } from 'src/constants/routes';

export const isProfileRoute = () => window.location.pathname.includes(ROUTES.PROFILE);
